export default __webpack_public_path__ + "static/Bugsnag-734062343cf142e99d601d3499802739.png";